import { useMutation } from "@apollo/client";
import { UPDATE_BAND } from "../graphql";
import { toast } from "react-toastify";
import { GET_BANDS } from "../../bands/graphql";
import { Button, CircularProgress } from "@mui/material";
import { Band } from "../../../__generated__/graphql";
import { callCompressor } from "../imageEdit/Upload";
import { useState } from "react";

export const CompressArtistImage = ({ band }: { band: Band }) => {
  const [updateBand, { loading: updateLoading, error }] = useMutation(
    UPDATE_BAND,
    {
      onCompleted: () => {
        toast("band updated");
      },
      refetchQueries: [GET_BANDS],
    }
  );
  const [isCompressing, setIsCompressing] = useState(false);

  const handlePress = async () => {
    if (!band.imageUrl || isCompressing || updateLoading) return;

    setIsCompressing(true);
    try {
      const url = await callCompressor(band.imageUrl, true);
      if (url !== band.imageUrl) {
        await updateBand({
          variables: {
            id: band.id,
            imageUrl: url,
          },
        });
      }
    } finally {
      setIsCompressing(false);
    }
  };

  if (!band || !band.imageUrl) return null;

  const isLoading = isCompressing || updateLoading;

  return (
    <Button
      variant="outlined"
      title="Compress"
      onClick={handlePress}
      disabled={isLoading}
      startIcon={isLoading ? <CircularProgress size={16} /> : undefined}
    >
      {isLoading ? "Compressing..." : "Compress"}
    </Button>
  );
};
